import { motion } from "framer-motion";

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className="block overflow-hidden pb-2 -mb-2">
        <motion.span
            className={`block will-change-transform ${className}`}
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ type: "spring", stiffness: 110, damping: 17, delay }}
        >
            {children}
        </motion.span>
    </span>
);
